import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import React, { useCallback } from 'react'
import { OfferFilterSelectButton, OfferFilterSelectButtonContent } from '../OfferFilterSelectButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import Switch from 'LuxKit/Switch/Switch'
import LineDoorIcon from 'LuxKit/Icons/line/LineDoorIcon'
import { stopPropagation } from 'lib/web/eventHandlerUtils'

interface Props {
  className?: string
  roomsConnected?: boolean
}

function OfferDesktopConnectingRoomsToggle({
  className,
  roomsConnected,
}: Props) {
  const dispatch = useOfferPageDispatch()

  const onConnectedRoomsChange = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleConnectedRooms })
  }, [dispatch])

  return <div className={className}>
    <OfferFilterSelectButton onClick={onConnectedRoomsChange}>
      <LineDoorIcon />
      <OfferFilterSelectButtonContent>
        <BodyText variant="medium" wrap="truncate">
          Connecting rooms
        </BodyText>
        <Caption variant="medium" colour="neutral-three" wrap="truncate">
          Subject to availability
        </Caption>
      </OfferFilterSelectButtonContent>
      <Switch
        checked={roomsConnected}
        onChange={onConnectedRoomsChange}
        onClick={stopPropagation}
      />
    </OfferFilterSelectButton>
  </div>
}

type MappedProps = Pick<Props,
  | 'roomsConnected'
>

export default withOfferPageState((state): MappedProps => ({
  roomsConnected: state.isMultiRoomConnected,
}), OfferDesktopConnectingRoomsToggle)
